import React from "react";
import { useNavigate } from "react-router-dom";
import { routeNames } from "../../../routes/routeNames";
import withAnimation from "../../../hooks/withAnimation";

const testimonials = [
  {
    name: "Sudesh Kaushik",
    rating: 5,
    content:
      "I am taking physiotherapy from Dr.Disha. Before signing up with conklin, due to chronic back pain I could hardly do anything and cannot sit for more than 2 hours. Every night I used to go to bed with pain. After a couple of sessions with Dr.Disha, I am seeing a good improvement with my",
    readMore: "#",
  },
  {
    name: "Preethi Agarwal",
    rating: 3.5,
    content:
      "Great experience and recover for backpain. I was suffering from backpain due to my IT life and constant lifting of my toddler, Conklin sessions have really helped me overcome the back pain also achive back strength. I was assigned with Dr",
    readMore: "#",
  },
  {
    name: "Sudesh Kaushik",
    rating: 5,
    content:
      "I am taking physiotherapy from Dr.Disha. Before signing up with conklin, due to chronic back pain I could hardly do anything and cannot sit for more than 2 hours. Every night I used to go to bed with pain. After a couple of sessions with Dr.Disha, I am seeing a good improvement with my",
    readMore: "#",
  },
  {
    name: "Preethi Agarwal",
    rating: 5,
    content:
      "Great experience and recover for backpain. I was suffering from backpain due to my IT life and constant lifting of my toddler, Conklin sessions have really helped me overcome the back pain also achive back strength. I was assigned with Dr",
    readMore: "#",
  },
  {
    name: "Sudesh Kaushik",
    rating: 3,
    content:
      "I am taking physiotherapy from Dr.Disha. Before signing up with conklin, due to chronic back pain I could hardly do anything and cannot sit for more than 2 hours. Every night I used to go to bed with pain. After a couple of sessions with Dr.Disha, I am seeing a good improvement with my",
    readMore: "#",
  },
  {
    name: "Preethi Agarwal",
    rating: 4,
    content:
      "Great experience and recover for backpain. I was suffering from backpain due to my IT life and constant lifting of my toddler, Conklin sessions have really helped me overcome the back pain also achive back strength. I was assigned with Dr",
    readMore: "#",
  },
  {
    name: "Sudesh Kaushik",
    rating: 4,
    content:
      "I am taking physiotherapy from Dr.Disha. Before signing up with conklin, due to chronic back pain I could hardly do anything and cannot sit for more than 2 hours. Every night I used to go to bed with pain. After a couple of sessions with Dr.Disha, I am seeing a good improvement with my",
    readMore: "#",
  },
  {
    name: "Preethi Agarwal",
    rating: 4,
    content:
      "Great experience and recover for backpain. I was suffering from backpain due to my IT life and constant lifting of my toddler, Conklin sessions have really helped me overcome the back pain also achive back strength. I was assigned with Dr",
    readMore: "#",
  },
  {
    name: "Sudesh Kaushik",
    rating: 1,
    content:
      "I am taking physiotherapy from Dr.Disha. Before signing up with conklin, due to chronic back pain I could hardly do anything and cannot sit for more than 2 hours. Every night I used to go to bed with pain. After a couple of sessions with Dr.Disha, I am seeing a good improvement with my",
    readMore: "#",
  },
  {
    name: "Preethi Agarwal",
    rating: 5,
    content:
      "Great experience and recover for backpain. I was suffering from backpain due to my IT life and constant lifting of my toddler, Conklin sessions have really helped me overcome the back pain also achive back strength. I was assigned with Dr",
    readMore: "#",
  },
];

const TestinomialsSection = () => {
  const navigate = useNavigate()
  return (
    <section className="relative py-16">
      <div className="container mx-auto text-center">
        <div className="relative mb-12">
          <h2 className="text-5xl font-extrabold text-primary">
            Healing Stories
          </h2>
          <div className="absolute left-0 right-0 mx-auto w-20 h-1 bg-primary mt-4"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="relative p-8 bg-white shadow-xl rounded-xl hover:shadow-2xl transition-shadow duration-300 mx-8 lg:mx-0"
            >
              <div className="absolute -top-5 -left-5 text-[10rem] text-indigo-200 opacity-20 leading-none">
                “
              </div>
              <div className="relative">
                <h3 className="text-2xl font-bold text-primary mb-2">
                  {testimonial.name}
                </h3>
                <div className="flex items-center justify-center mb-4">
                  {Array(5).fill().map((_, i) => (
                    <svg key={i} className={`w-6 h-6 ${i<testimonial.rating ? "text-yellow-500" :"text-gray-200"} `} fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927C9.335 2.13 10.665 2.13 10.951 2.927L12.362 7.11C12.477 7.451 12.791 7.676 13.146 7.676H17.546C18.392 7.676 18.791 8.747 18.149 9.226L14.367 12.123C14.095 12.333 13.973 12.724 14.087 13.061L15.498 17.244C15.784 18.041 14.796 18.713 14.155 18.234L10.373 15.337C10.101 15.127 9.899 15.127 9.627 15.337L5.845 18.234C5.204 18.713 4.216 18.041 4.502 17.244L5.913 13.061C6.027 12.724 5.905 12.333 5.633 12.123L1.851 9.226C1.209 8.747 1.608 7.676 2.454 7.676H6.854C7.209 7.676 7.523 7.451 7.638 7.11L9.049 2.927Z" />
                    </svg>
                  ))}
                </div>
                <p className="text-gray-600">{testimonial.content}</p>
                <a
                  href={testimonial.readMore}
                  className="text-primary font-semibold mt-4 inline-block"
                  onClick={()=>navigate(routeNames.testinomialsDetail)}
                >
                  Read more
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <button onClick={() => navigate(routeNames.testinomialsShareYourStory)} className="bg-primary text-white py-4 px-8 rounded-full shadow-lg hover:bg-secondary hover:shadow-xl transition-all duration-300">
            Share Your Story
          </button>
        </div>
      </div>
    </section>
  );
};

export default withAnimation(TestinomialsSection);
